import React from "react";
import { AIChatWidgetProps } from "./AIChatWidget";
import AIChatWidgetWithStorage from "./AIChatWidgetWithStorage";

/**
 * A pre-wrapped version of AIChatWidget with ErrorBoundary and StorageProvider
 * This simplifies the integration in initAIChatWidget.ts
 *
 * This component provides:
 * 1. Error handling with ErrorBoundary
 * 2. Enhanced storage with IndexedDB (falls back to localStorage)
 */
const WrappedAIChatWidget: React.FC<AIChatWidgetProps> = (props) => {
  return <AIChatWidgetWithStorage {...props} />;
};

export default WrappedAIChatWidget;
